const fontOptions = [
  {
    type: "sans serif",
    font: "Inter",
  },
  {
    type: "serif",
    font: "Lora",
  },
  {
    type: "mono",
    font: "Inconsolata",
  },
];

export default fontOptions;
